import type {RouteRecordRaw} from "vue-router";

export const routeName = 'CabinetMain';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'main',
    component: () => import('@/pages/CabinetMain'),
    meta: {
        isHide: true,
    }
};
